import axios from "axios";
import {
  COMPLAINT_REQUIREMENT_LIST_REQUEST,
  COMPLAINT_REQUIREMENT_LIST_SUCCESS,
  COMPLAINT_REQUIREMENT_LIST_FAIL,
  COMPLAINT_REQUIREMENT_SINGLE_REQUEST,
  COMPLAINT_REQUIREMENT_SINGLE_SUCCESS,
  COMPLAINT_REQUIREMENT_SINGLE_FAIL,
  CREATE_COMPLAINT_REQUIREMENT_REQUEST,
  CREATE_COMPLAINT_REQUIREMENT_SUCCESS,
  CREATE_COMPLAINT_REQUIREMENT_FAIL,
  UPDATE_COMPLAINT_REQUIREMENT_REQUEST,
  UPDATE_COMPLAINT_REQUIREMENT_SUCCESS,
  UPDATE_COMPLAINT_REQUIREMENT_FAIL,
  DELETE_COMPLAINT_REQUIREMENT_REQUEST,
  DELETE_COMPLAINT_REQUIREMENT_SUCCESS,
  DELETE_COMPLAINT_REQUIREMENT_FAIL,
} from "constants/complaintRequirementConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import {
  getComplaintsList,
  getComplaintSingle,
} from "actions/complaintActions";
import { getProductList, getSingleProduct } from "actions/productActions";
import ComplaintRequirementsService from "services/complaint-requirements-service";

export const getComplaintRequirementsList =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: COMPLAINT_REQUIREMENT_LIST_REQUEST,
      });

      const res = await ComplaintRequirementsService.getComplaintRequirements();
      console.log(
        "🚀 ~ file: complaintRequirementActions.js:30 ~ getComplaintRequirementsList ~ res:",
        res
      );

      dispatch({
        type: COMPLAINT_REQUIREMENT_LIST_SUCCESS,
        payload: res.foundComplaintRequirements,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: complaintRequirementActions.js:37 ~ getComplaintRequirementsList ~ error:",
        error
      );
      dispatch({
        type: COMPLAINT_REQUIREMENT_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const getComplaintRequirementsSingle =
  (complaintRequirementId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: COMPLAINT_REQUIREMENT_SINGLE_REQUEST,
      });

      const res =
        await ComplaintRequirementsService.getSingleComplaintRequirements(
          complaintRequirementId
        );
      console.log(
        "🚀 ~ file: complaintRequirementActions.js:55 ~ getComplaintRequirementsSingle ~ res:",
        res
      );

      dispatch({
        type: COMPLAINT_REQUIREMENT_SINGLE_SUCCESS,
        payload: res.foundComplaintRequirement,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: complaintRequirementActions.js:62 ~ getComplaintRequirementsSingle ~ error:",
        error
      );
      dispatch({
        type: COMPLAINT_REQUIREMENT_SINGLE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const createNewComplaintRequirement =
  (complaintRequirement) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_COMPLAINT_REQUIREMENT_REQUEST,
      });

      const res =
        await ComplaintRequirementsService.createComplaintRequirements(
          complaintRequirement
        );
      dispatch(getProductList());
      dispatch(getSingleProduct(complaintRequirement.product));

      dispatch({
        type: CREATE_COMPLAINT_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: complaintRequirementActions.js:88 ~ createNewComplaintRequirement ~ error:",
        error
      );
      dispatch({
        type: CREATE_COMPLAINT_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const complaintRequirementUpdating =
  (complaintRequirementId, complaintRequirement) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_COMPLAINT_REQUIREMENT_REQUEST,
      });

      const res = await ComplaintRequirementsService.editComplaintRequirements(
        complaintRequirementId,
        complaintRequirement
      );
      console.log(
        "🚀 ~ file: complaintRequirementActions.js:106 ~ complaintRequirementUpdating ~ res:",
        res
      );

      dispatch(getProductList());
      dispatch(getSingleProduct(complaintRequirement.product));

      dispatch({
        type: UPDATE_COMPLAINT_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: complaintRequirementActions.js:116 ~ complaintRequirementUpdating ~ error:",
        error
      );
      dispatch({
        type: UPDATE_COMPLAINT_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const complaintRequirementDeleting =
  (complaintRequirementId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: DELETE_COMPLAINT_REQUIREMENT_REQUEST,
      });

      const res = await axios.delete(
        `${REACT_APP_API_URL}/admin/services/${complaintRequirementId}`
      );

      dispatch({
        type: DELETE_COMPLAINT_REQUIREMENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      dispatch({
        type: DELETE_COMPLAINT_REQUIREMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };
